export default function getResource(label, vars = []) {
    const resources = {
        color: 'Couleur',
        size: 'Format',
        edit: 'Modifier',
        type: 'Type',
        scent: 'Senteur',
        sizeConcentration: 'Dimension + Concentration',
        save: 'Enregistrer',
        cancel: 'Annuler',
        gotIt: 'Compris',
        noVariants: 'Cet élément ne comporte aucune option modifiable.',
        genericErrorMessage: 'Une erreur s’est produite, veuillez réessayer.',
        changesNotSaved: 'Modifications non enregistrées',
        duplicateItem: 'Article en double'
    };

    return resources[label];
}
